const common = {
  // Navigation
  "nav.about": "About Us",
  "nav.technology": "Technology",
  "nav.aesthetics": "Services",
  "nav.compliance": "Quality & Compliance",
  "nav.contact": "Contact Us",
  
  // Hero Section
  "hero.badge": "Since 2004: Two Decades of Excellence in Quality",
  "hero.title1": "Precision Aluminum",
  "hero.title2": "Surface Engineering Expert",
  "hero.description": "Specializing in Type III Hardcoat Anodizing for 2000/6000/7000 Series High-Strength Aluminum Alloys",
  "hero.description2": "Inheriting Craftsmanship, Driving Digital & Sustainable Transformation",
  "hero.learnMore": "Learn More",
  "hero.contactUs": "Contact Us",
  
  // About Section
  "about.subtitle": "ABOUT HSIN YU ENTERPRISE",
  "about.title1": "Since Our Founding in 2004",
  "about.title2": "Hsin Yu Enterprise Has Over 20 Years of Expertise in Precision Surface Treatment",
  "about.description": "We specialize in hardcoat anodizing for 2000, 6000, and 7000 series high-strength aluminum alloys, with over 20 years of experience processing aerospace-grade materials. Currently undergoing comprehensive smart manufacturing transformation, implementing CQI-12 and IATF 16949 management principles to provide stable and compliant green supply chain solutions for international manufacturers.",
  "about.viewTechnology": "View Technology",
  "about.qualityCompliance": "Quality & Compliance",
  "about.stat.founded": "Year Founded",
  "about.stat.experience": "Years of Experience",
  "about.stat.series": "Alloy Series",
  "about.stat.traceability": "Quality Traceability",
  
  // Certifications Section
  "cert.title": "International Certification System",
  "cert.description": "Strictly following international standards, ensuring full traceability of every process",
  "cert.certified": "Certified",
  "cert.applied": "Applied",
  "cert.iso9001": "ISO 9001",
  "cert.iso9001.desc": "Quality Management System",
  "cert.iso14001": "ISO 14001",
  "cert.iso14001.desc": "Environmental Management System",
  "cert.iatf": "IATF 16949",
  "cert.iatf.desc": "Automotive Quality Management Principles",
  "cert.cqi12": "CQI-12",
  "cert.cqi12.desc": "Special Process Assessment for Plating",
  "cert.rohs": "RoHS Compliant",
  "cert.rohs.desc": "EU Hazardous Substances Restriction Directive",
  "cert.reach": "REACH Compliant",
  "cert.reach.desc": "EU Chemical Registration & Authorization",
  "cert.ca65": "California Prop 65",
  "cert.ca65.desc": "US California Safe Drinking Water Act",
  
  // ESG Section
  "esg.subtitle": "SUSTAINABILITY & ESG",
  "esg.title": "Sustainability & ESG Practices",
  "esg.description": "Hsin Yu Enterprise firmly believes that corporate sustainability and environmental protection are inseparable. We actively engage in ESG practices, comprehensively implementing sustainable management principles from environmental protection and social responsibility to corporate governance",
  "esg.environment": "Environment (E)",
  "esg.env1": "Wastewater treatment system meets international standards",
  "esg.env2": "Continuously reducing carbon emissions and energy consumption",
  "esg.env3": "Using eco-friendly plating materials and processes",
  "esg.env4": "Regular environmental impact assessments",
  "esg.social": "Social (S)",
  "esg.soc1": "Providing safe and healthy work environment",
  "esg.soc2": "Emphasizing employee training and career development",
  "esg.soc3": "Supporting local community development programs",
  "esg.soc4": "Establishing fair and transparent supply chain management",
  "esg.governance": "Governance (G)",
  "esg.gov1": "Establishing comprehensive internal control systems",
  "esg.gov2": "Following business ethics and integrity principles",
  "esg.gov3": "Regular disclosure of corporate operations",
  "esg.gov4": "Continuously optimizing risk management mechanisms",
  "esg.stat1": "Carbon Reduction Target",
  "esg.stat1.year": "(2025)",
  "esg.stat2": "Wastewater Treatment",
  "esg.stat2.sub": "Compliance Rate",
  "esg.stat3": "Raw Material",
  "esg.stat3.sub": "Traceability",
  "esg.stat4": "Major Safety",
  "esg.stat4.sub": "Incident Record",
  
  // Services Section
  "services.subtitle": "SERVICES & TECHNOLOGY",
  "services.title": "Services",
  "services.description": "Providing comprehensive electroplating surface treatment solutions, from process design to quality control, we meet the stringent requirements of various industries with professional technology and smart manufacturing",
  "services.automotive": "Automotive Components",
  "services.automotive.desc": "IATF 16949 Compliant",
  "services.precision": "Precision Hardware",
  "services.precision.desc": "High-Precision Surface Treatment",
  "services.sports": "Sports Equipment",
  "services.sports.desc": "Durability & Aesthetics Combined",
  "services.medical": "Medical Equipment",
  "services.medical.desc": "Medical-Grade Standards",
  "services.medicalDevice": "Medical Devices",
  "services.medicalDevice.title": "Artificial Joint Specialized Treatment",
  "services.medicalDevice.desc": "Providing conversion coatings with excellent biocompatibility and high stability, meeting the stringent standards of medical aids. Our surface treatment technology ensures artificial joints maintain stable performance during long-term use, providing patients with safe and reliable medical solutions.",
  "services.medicalDevice.tag1": "Biocompatibility",
  "services.medicalDevice.tag2": "Medical-Grade",
  "services.medicalDevice.tag3": "Long-term Stability",
  "services.mold": "Precision Molds",
  "services.mold.title": "Hardcoat + PTFE Composite Treatment",
  "services.mold.desc": "Developed specifically for packaging container molds, combining the durability of hardcoat with the non-stick properties of PTFE, significantly improving demolding efficiency and lifespan. This innovative composite treatment technology brings revolutionary performance improvements to the mold industry.\u00A0 \u00A0 \u00A0\u00A0",
  "services.mold.tag1": "Non-stick Properties",
  "services.mold.tag2": "High Demolding Efficiency",
  "services.mold.tag3": "Extended Lifespan",
  "services.bicycle": "High-End Bicycles & Motorcycles",
  "services.bicycle.title": "6000 & 7000 Series Key Components",
  "services.bicycle.desc": "For 6000 and 7000 series high-strength materials, providing surface strengthening for key components such as shock absorbers and connecting rods. Our professional treatment technology ensures these high-performance parts maintain excellent performance under extreme conditions.",
  "services.bicycle.tag1": "Shock Absorber Specialized",
  "services.bicycle.tag2": "High-Strength Materials",
  "services.bicycle.tag3": "Extreme Durability",
  
  // Technology Section
  "tech.subtitle": "TYPE III HARDCOAT ANODIZING",
  "tech.title": "Precision Aluminum Surface Engineering",
  "tech.description": "Using advanced electrochemical process technology to transform aluminum alloy surfaces into high-hardness Al₂O₃ ceramic layers, providing excellent wear resistance and protective performance, compliant with CQI-12 special process assessment standards",
  "tech.natural": "Hardcoat Anodizing (Natural)",
  "tech.natural.sub": "Natural Finish",
  "tech.natural.desc": "Through precision electrochemical processes, transforming AL 2000/6000/7000 series aluminum alloy surfaces into high-hardness Al₂O₃ ceramic structures. This process is conducted under micron-level precision control, ensuring coating uniformity and structural integrity, providing excellent mechanical protection.",
  "tech.natural.feat1": "Integrated with Base Material",
  "tech.natural.feat1.desc": "Transforms aluminum substrate into Al₂O₃ ceramic structure, forming a protective layer integrated with the base material that never peels",
  "tech.natural.feat2": "High Hardness & Wear Resistance",
  "tech.natural.feat2.desc": "Hardness can reach HV 400-600, significantly improving surface wear resistance and service life",
  "tech.natural.feat3": "Micron-Level Precision Control",
  "tech.natural.feat3.desc": "Precisely controlling surface microstructure to achieve dimensional tolerances meeting design specifications",
  "tech.black": "Hardcoat Anodizing (Hard Black)",
  "tech.black.sub": "Hard Black Finish",
  "tech.black.desc": "Through precision chemical polishing technology, integrating high-saturation black dye technology on the basis of Type III hardcoat anodizing. Dye molecules deeply penetrate into the porous oxide layer structure, forming a durable deep black appearance while retaining complete physical protection and UV resistance.",
  "tech.black.feat1": "Retains Hardcoat Physical Properties",
  "tech.black.feat1.desc": "Equal high-strength protection performance, presenting matte or glossy black visual expression",
  "tech.black.feat2": "Zero Color Difference Premium Quality",
  "tech.black.feat2.desc": "High-saturation black dye deep penetration, presenting uniform and consistent deep black aesthetics",
  "tech.black.feat3": "UV Resistant & Fade-Proof",
  "tech.black.feat3.desc": "Excellent UV resistance, no fading or deterioration during long-term use",
  "tech.note.title": "Technical Note: 2000 Series Alloy Expertise",
  "tech.note.desc": "Hsin Yu Enterprise possesses professional technical capabilities for processing AL 2000 series high-copper content aluminum alloys. The 2000 series is widely used in aerospace and high-end sports equipment due to its high-strength characteristics, but its high copper content significantly increases anodizing difficulty. Through precise process parameter control and proprietary formulations, we have successfully overcome this technical challenge, ensuring 2000 series alloys can also achieve uniform, high-quality hardcoat anodizing results.",
  "tech.consult": "Consult Technical Specifications",
  
  // Product Features Section
  "product.subtitle": "PRODUCT FEATURES",
  "product.title": "Product Introduction",
  "product.description": "Surface treatment technology designed specifically for high-strength aluminum alloys, providing excellent wear resistance and protective performance, suitable for high-end bicycle parts and sports equipment",
  "product.natural": "Hard Anodizing (Natural)",
  "product.natural.desc": "Hardcoat anodizing technology designed specifically for 7075 and 6066 aluminum alloys. Through precision electrochemical processes, forming a hard oxide layer on the aluminum surface, providing excellent wear resistance and corrosion resistance while retaining the natural texture and luster of the metal.",
  "product.natural.feat1": "Suitable for 7075 & 6066 Aluminum Alloys",
  "product.natural.feat2": "Excellent Wear Resistance & Surface Hardness",
  "product.natural.feat3": "Retains Original Metal Texture & Luster",
  "product.natural.feat4": "Superior Corrosion Protection Performance",
  "product.black": "Hard Anodizing (Black)",
  "product.black.desc": "Hardcoat anodizing technology combining high-strength protection with deep black aesthetics. Also suitable for 7075 and 6066 aluminum alloys, providing top-tier wear protection while giving products a durable deep black appearance, perfectly suited for high-end bicycle parts and professional sports equipment.",
  "product.black.feat1": "Equal High-Strength Protection Performance",
  "product.black.feat2": "Deep and Lasting Black Aesthetic Appearance",
  "product.black.feat3": "Suitable for High-End Bicycle Parts",
  "product.black.feat4": "Preferred Surface Treatment for Professional Sports Equipment",
  "product.inquire": "Inquire Product Specifications",
  
  // Compliance Section
  "compliance.subtitle": "GLOBAL COMPLIANCE",
  "compliance.title": "Global Supply Chain Compliance Assurance",
  "compliance.description": "We strictly implement Fox Factory supplier 193-item audit standards, practicing ESG sustainable operations",
  "compliance.quality": "Quality Standards",
  "compliance.quality1": "Following ISO 9001 Quality Management System",
  "compliance.quality2": "Implementing CQI-12 Plating System Assessment",
  "compliance.quality3": "Applying IATF 16949 Management Principles",
  "compliance.quality4": "PPAP Data Management & Traceability",
  "compliance.environment": "Environmental Standards",
  "compliance.env1": "Following ISO 14001 Environmental Management System",
  "compliance.env2": "Equipped with Professional Wastewater Treatment Facilities",
  "compliance.env3": "Full Process Compliant with RoHS 3.0 Standards",
  "compliance.env4": "Compliant with REACH Chemical Regulations",
  "compliance.international": "International Regulations",
  "compliance.int1": "Strictly Complying with California Prop 65",
  "compliance.int2": "Ensuring Global Trade Compliance",
  "compliance.int3": "Regular Regulatory Compliance Updates",
  "compliance.int4": "Providing Complete Compliance Documentation",
  "compliance.social": "Social Responsibility",
  "compliance.soc1": "Compliant with RBA Responsible Business Alliance Guidelines",
  "compliance.soc2": "Protecting Labor Rights & Occupational Safety",
  "compliance.soc3": "Practicing Integrity Management & Business Ethics",
  "compliance.soc4": "Establishing Transparent Supply Chain Management",
  
  // CTA Section
  "cta.title1": "PARTNER WITH",
  "cta.title2": "EXCELLENCE",
  "cta.description": "Partner with Hsin Yu Enterprise / Creating a Green Smart Manufacturing Future Together",
  "cta.button": "Contact Now",
  
  // Contact Section
  "contact.title": "Contact Us",
  "contact.description": "Welcome to contact us, we will serve you wholeheartedly",
  "contact.phone": "Phone",
  "contact.email": "Email",
  "contact.address": "Address",
  "contact.addressValue": "No. 35-1, Ln. 268, Xinshu Rd., Xinzhuang Dist., New Taipei City, Taiwan",
  "contact.openMap": "Open in Google Maps",
  "contact.form.name": "Name",
  "contact.form.namePlaceholder": "Please enter your name",
  "contact.form.company": "Company Name",
  "contact.form.companyPlaceholder": "Please enter company name",
  "contact.form.email": "Email",
  "contact.form.phone": "Phone",
  "contact.form.message": "Message",
  "contact.form.messagePlaceholder": "Please describe your requirements or questions",
  "contact.form.submit": "Submit Inquiry",
  
  // Footer
  "footer.companyName": "Hsin Yu Enterprise",
  "footer.companyNameEn": "Hsin Yu Enterprise Co., Ltd.",
  "footer.tagline": "Precision Aluminum Surface Engineering Expert | Since 2004",
  "footer.newsletter": "Subscribe to Technical Newsletter",
  "footer.subscribe": "Subscribe",
  "footer.aboutUs": "About Us",
  "footer.coreTech": "Core Technology",
  "footer.certifications": "Certifications",
  "footer.typeIII": "Type III Hardcoat",
  "footer.matte": "Matte Finish",
  "footer.polish": "Polished Finish",
  "footer.qualityMgmt": "Quality Management",
  "footer.copyright": "© 2026 Hsin Yu Enterprise Co., Ltd. All Rights Reserved.",
  
  // Language
  "lang.zh": "中文",
  "lang.en": "English"
};

export default common;
